import React, { useState, useEffect, useRef } from 'react';
import './Tooltip.css';
import { logEvent } from '../../utils/Logger'

interface TooltipProps {
  content: string;
  children: React.ReactElement;
  color: string; 
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const Tooltip: React.FC<TooltipProps> = ({ content, children, color, onMouseEnter, onMouseLeave }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [tooltipStyle, setTooltipStyle] = useState({});
  const tooltipRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = (event: React.MouseEvent<HTMLSpanElement>) => {
    onMouseEnter && onMouseEnter()
    const rect = event.currentTarget.getBoundingClientRect();
    const spaceRight = window.innerWidth - rect.right;
    const spaceBottom = window.innerHeight - rect.bottom;

    let style: React.CSSProperties = {
      left: `${rect.right + 10}px`,
      top: `${rect.top - 6}px`,
      backgroundColor: color, 
    };

    // if (spaceRight < 310) {
    //   style.left = `${rect.left - 310}px`;
    // }

    // if right is too close to the edge of the screen and left is spacious, move tooltip to the left
    if (spaceRight < 350 && rect.left > 350) {
      style.left = `${rect.left - 350}px`;
    }
    // if both side is too close to the edge of the screen, move tooltip to the bottom
    if (spaceRight < 350 && rect.left < 350) {
      style.left = `${rect.left}px`;
      style.top = `${rect.bottom + 10}px`;
    }

    if (spaceBottom < 100) {
      style.top = 'auto';
      style.bottom = '10px';
    }

    setTooltipStyle(style);
    setIsVisible(true);

    // get the type and the text of the children element
    // Log the tooltip hover event
    console.log(children, children.type)
    const payload = {
      name: typeof(children.type) === 'string' ? children.type : children.type.name,
      childProps: children.props,
      content: content
    }
    logEvent('tooltip_hover', JSON.stringify(payload), window.location.href);
  };

  const handleMouseLeave = () => {
    onMouseLeave && onMouseLeave()
    setIsVisible(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
        setIsVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <span
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {isVisible && (
        <div className="tag-tooltip" style={tooltipStyle} ref={tooltipRef}>
          {content}
        </div>
      )}
    </span>
  );
};

export default Tooltip;